import {Component, Input, OnInit, OnChanges, SimpleChanges, OnDestroy} from '@angular/core';
import {SubscriptionsService} from '../_services/subscriptions.service';
import {Subscription} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import 'rxjs/add/operator/take';

@Component({
  selector: 'app-jinni-errors-messages',
  templateUrl: './jinni-errors-messages.component.html',
  styleUrls: ['./jinni-errors-messages.component.scss']
})
export class JinniErrorsMessagesComponent implements OnInit, OnChanges, OnDestroy {
  jinniErrorsMessages: Subscription;
  closeErrorMessage: Subscription;
  errorCode: string;
  message: string;
  createBubble: boolean;
  showtime: boolean;
  preventClose: boolean;
  @Input() close;

  constructor(private subscriptionsService: SubscriptionsService, private translate: TranslateService) {

    this.jinniErrorsMessages = this.subscriptionsService.getJinniError().subscribe(data => {
      if (data !== 0) {
        this.createBubble = true;
        this.showtime = false;
        this.preventClose = false;
        this.errorCode = data;
        const errorId = `errors.${data}`;
        this.translate.get(errorId).subscribe(t => {
          if (t !== errorId) {
            this.message = t;
            this.makeShowtime();
          } else {
            this.translate.get('errors.Default').subscribe(g => {
              this.message = g;
              this.makeShowtime();
            });
          }
        });
      } else {
        this.createBubble = false;
        this.showtime = false;
        this.preventClose = false;
      }
    });

    this.closeErrorMessage = this.subscriptionsService.getCloseModal().subscribe(data => {
      if (data) {
        this.closeBubble();
      }
    });
  }

  ngOnDestroy() {
    if (this.jinniErrorsMessages) {
      this.jinniErrorsMessages.unsubscribe();
    }
    if (this.closeErrorMessage) {
      this.closeErrorMessage.unsubscribe();
    }
  }

  ngOnInit() {
    this.message = '';
    this.errorCode = '';
    this.showtime = false;
    this.createBubble = false;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.close && changes.close.currentValue === true) {
      this.closeBubble();
    }
  }

  makeShowtime() {
    setTimeout(() => {
      this.showtime = true;
    }, 500);
  }

  closeBubble() {
    this.showtime = false;
    setTimeout(() => {
      this.createBubble = false;
    }, 500);
  }

  giveMeTime() {
    setTimeout(() => {
      if (!this.preventClose) {
        this.closeBubble();
      } else {
        this.giveMeTime();
      }
    }, 5000);
  }

}
